import React from 'react';
import Icon from '@/components/Icon';
import Avatar from '@/components/Avatar';
import StatusBadge from '@/components/StatusBadge';

function formatBirth(iso) {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
}

function ageSuffix(n) {
  if (n == null) return '';
  const mod10 = n % 10, mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return 'год';
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'года';
  return 'лет';
}

export default function StudentsTable({
  rows, selected, toggle, toggleAll, allSelected,
  showAvatars, sort, setSort, onOpen,
}) {
  const th = (key, label, w) => (
    <th style={w ? { width: w } : undefined} onClick={() => setSort(key)}>
      <button className={'th' + (sort.key === key ? ' is-sorted' : '')}>
        <span>{label}</span>
        {sort.key === key && (
          <Icon
            name="chevronDown"
            size={10}
            className={'th__arrow ' + (sort.dir === 'asc' ? 'th__arrow--up' : '')}
          />
        )}
      </button>
    </th>
  );

  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th style={{ width: 36 }}>
              <input type="checkbox" checked={allSelected} onChange={toggleAll} />
            </th>
            {th('name', 'Ученик')}
            {th('class', 'Класс', 88)}
            {th('birthdate', 'Дата рождения', 160)}
            {th('status', 'Статус', 110)}
            <th style={{ width: 220 }}>Родитель / контакт</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={6} style={{ textAlign: 'center', padding: 32, color: 'var(--fg-muted)' }}>
              Ничего не найдено
            </td></tr>
          )}
          {rows.map((r) => {
            const isSel = selected.has(r.id);
            const isArchive = r.status === 'archive';
            const fio = `${r.familyName} ${r.firstName} ${r.midName || ''}`.trim();
            return (
              <tr
                key={r.id}
                className={[
                  isSel ? 'is-selected' : '',
                  isArchive ? 'student-row--archive' : '',
                ].filter(Boolean).join(' ')}
                onDoubleClick={() => onOpen?.(r.id)}
              >
                <td>
                  <input type="checkbox" checked={isSel} onChange={() => toggle(r.id)} />
                </td>
                <td>
                  <div className="cell-student">
                    {showAvatars && <Avatar name={fio} />}
                    <div className="cell-student__text">
                      <button className="cell-student__name" onClick={() => onOpen?.(r.id)}>
                        {r.familyName} {r.firstName?.[0]}.{r.midName ? ` ${r.midName[0]}.` : ''}
                      </button>
                      <span className="cell-student__id">ID {r.id}</span>
                    </div>
                  </div>
                </td>
                <td><span className="mono">{r.class?.label || '—'}</span></td>
                <td className="muted">
                  <span>{formatBirth(r.birthdate)}</span>
                  {r.age != null && <span className="hint"> · {r.age} {ageSuffix(r.age)}</span>}
                </td>
                <td><StatusBadge status={r.status} /></td>
                <td>
                  {r.parent ? (
                    <div className="cell-parent">
                      <div className="cell-parent__name">{r.parent.name}</div>
                      <div className="cell-parent__phone mono">{r.parent.phone || '—'}</div>
                    </div>
                  ) : (
                    <span className="muted hint">—</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
